/* eslint-disable jsx-a11y/media-has-caption */
import React, { lazy, useState } from 'react';
import { Modal } from '@mui/material';
import { useLocation, useRouteMatch } from 'react-router';
import styles from './welcome.module.scss';
import {
  FaceBookIcon,
  InstagramIcon,
  SnapchatIcon,
  TikTokIcon,
  TwitterIcon,
  WelcomeVideo,
  FastSlowIcon,
  BitmojiIcon,
  Pic2ArtIcon,
  PreEnroll,
  ProtectPromoteIcon,
  Bonus,
  SocialShareIcon,
  TrimIcon,
  VideoPlaceholder,
  WelcomeModal,
  IconMute,
  IconUnmute,
  QuickCamCoins,
  WhatsAppIcon,
  MessengerIcon,
  ShareChatIcon,
  MojIcon,
  ChingariIcon,
  JoshIcon,
  XIcon,
  SocialFiIcon,
  GamificationIcon,
  GameCoinIcon,
  FreeBetaIcon,
  LandingIntroVideo,
  ThumbnailSummary,
} from '../../../../assets/images';
import RegisterBlock from './register-block';
import useWindowDimensions from '../../../../common/hooks/useWindowDimensions';
import { UserService } from '../../../../common/services/user/user.service';
import ReferralModal from './referral-modal.component';
import FreeBeta from './free-beta.component';

const data = [
  {
    image: FastSlowIcon,
    title: 'Real-Time Special Effects',
    description: '1-touch fast & slow motion editing while recording',
  },
  {
    image: TrimIcon,
    title: 'Quickie Video Editor',
    description: 'Quickly trim, cut, crop, voiceover and share.',
  },
  {
    image: SocialShareIcon,
    title: 'Social Sharing',
    description: (
      <div>
        <div className={styles.featureDescription}>
          QuickShare<sup>TM</sup> on
        </div>
        <div className={styles.iconsRow}>
          <img src={TikTokIcon} alt="TikTok" />
          <img src={FaceBookIcon} alt="Facebook" />
          <img src={InstagramIcon} alt="Instagram" />
          <img src={SnapchatIcon} alt="Snapchat" />
          <img src={WhatsAppIcon} alt="WhatsApp" />
          <img src={MessengerIcon} alt="Messenger" />
          <img src={ShareChatIcon} alt="Sharechat" />
          <img src={MojIcon} alt="Moj" />
          <img src={ChingariIcon} alt="Chingari" />
          <img src={JoshIcon} alt="Josh" />
          <img src={XIcon} alt="X" />
        </div>
      </div>
    ),
  },
  {
    image: SocialFiIcon,
    title: 'QuickCam Crypto Tipping',
    description: 'Get tipped with community meme coins.',
  },
  {
    image: GamificationIcon,
    title: 'Gamification',
    description: 'Challenges, Contest, Prizes and Leaderboards.',
  },
  {
    image: GameCoinIcon,
    title: 'QuickCam Referral Points',
    description: 'Converts into Quickie Community Meme Coins!',
  },
  {
    image: Bonus,
    title: 'Make Money Sharing Quickie Videos',
    description: 'Earn Crypto Tips from Friends, Fans and Followers',
  },
  {
    image: PreEnroll,
    title: 'Free In Beta',

    description: (
      <p style={{ margin: 0, padding: 0 }}>Premium Free Trial In Beta</p>
    ),
  },
];

const videos = [
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/welcome.mov',
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/pictoart.mov',
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/videoeditor.mov',
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/bitmoji.mov',
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/share.mov',
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/invite-wizard.mov',
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/infinity-bonus.mov',
  'https://quickcam-static-videos.s3.us-east-2.amazonaws.com/launch.mov',
];

const userServices = new UserService();

const Welcome = (props: {
  isLoggedIn: boolean;
  isLoadingReferrer: boolean;
  referredBy: any;
  getReferrerUser: any;
}) => {
  const [focusID, setFocusID] = useState<number>() as any;
  const [videoSrc, setVideoSrc] = useState(null) as any;
  const [muted, setMuted] = useState(false) as any;
  const [isTimerStarter, setIsTimerStarted] = useState(false);
  const { width } = useWindowDimensions();
  const { isLoggedIn, isLoadingReferrer, referredBy, getReferrerUser } = props;
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const location = useLocation();
  const match = useRouteMatch();
  const { search } = location;

  const handleActions = (idx: number, isKeepIntervalGoingOn?: boolean) => {
    setFocusID(idx);
    // setVideoSrc(videos[idx % videos.length]);
    // if (idx % videos.length === 0) {
    //   setVideoSrc(LandingIntroVideo);
    // }
    setVideoSrc(LandingIntroVideo);
  };

  const handleShadowOnFocus = (event: { currentTarget: any }) => {
    const element = event.currentTarget;
    element?.classList.add(styles.shadow);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    handleActions(0);
  };

  const handleReferralClose = () => {
    handleActions(0);
  };

  function renderButton(
    idx: number,
    icon: string,
    altText: string,
  ): React.ReactNode {
    return (
      <div
        id="btnIcon"
        // className={
        //   focusID === idx
        //     ? [styles.optionBtn, styles.shadow].join(' ')
        //     : [styles.optionBtn, styles.noshadow].join(' ')
        // }
        // onClick={() => handleActions(idx)}
        onFocus={e => handleShadowOnFocus(e)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // cursor: 'pointer',
        }}
      >
        <img
          src={icon}
          alt={altText}
          style={{
            width: '70px',
            height: '70px',
            objectFit: 'contain',
          }}
        />
      </div>
    );
  }
  return (
    <>
      {!isLoadingReferrer && !isTimerStarter && (
        <>
          {!referredBy?._id && !isLoadingReferrer ? (
            <Modal
              open={isModalVisible}
              onClose={closeModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div onClick={closeModal}>
                <img
                  className={styles.modalImage}
                  src={WelcomeModal}
                  alt="WelcomeModal"
                />
              </div>
            </Modal>
          ) : (
            <ReferralModal
              referredBy={referredBy}
              onClose={handleReferralClose}
              getReferrerUser={(channelId: string, startNow: boolean) => {
                getReferrerUser(channelId, startNow);
                setIsTimerStarted(true);
              }}
            />
          )}
        </>
      )}

      <section className={styles.welcomeSection} id="home">
        <div className={styles.welcomeHeader}>
          <div className={styles.welcomeHeaderContainer}>
            <div className={styles.welcomeText}>Welcome to QuickCam!</div>
            {width < 768 && (
              <div className={styles.welcomeDescription}>
                New Patented Camera App Ecosystem
              </div>
            )}
          </div>
          {width > 768 && (
            <div className={styles.welcomeDescription}>
              New Patented Camera App Ecosystem
            </div>
          )}
        </div>
      </section>
      {/* <RegisterBlock isLoggedIn={isLoggedIn} /> */}
      <section>
        <div className={styles.mWebWelcomeContainer}>
          <div className={styles.webWelcomeContent}>
            <div className={[styles.options, styles.left].join(' ')}>
              <div className={[styles.option, styles.first].join(' ')}>
                <div>
                  <div>
                    <div className={styles.featureTitle}>
                      Real-Time Video Special Effects
                    </div>
                    <div className={styles.featureDescription}>
                      1-touch fast & slow motion editing while recording
                    </div>
                  </div>
                  {renderButton(0, FastSlowIcon, 'Pic2Art')}
                </div>
              </div>
              <div className={[styles.option, styles.second].join(' ')}>
                <div>
                  <div>
                    <div className={styles.featureTitle}>
                      {' '}
                      Quickie Video Editor{' '}
                    </div>
                    <div className={styles.featureDescription}>
                      Quickly Trim, Cut, Crop, Voiceover and Share.
                    </div>
                  </div>
                  {renderButton(2, TrimIcon, 'Pic2Art')}
                </div>
              </div>
              <div className={[styles.option, styles.second].join(' ')}>
                <div>
                  <div>
                    <div className={styles.featureTitle}>Social Sharing</div>
                    <div className={styles.featureDescription}>
                      Quickly Share On Social Media
                    </div>
                    {/* <div className={styles.iconsRow}>
                      <img src={TikTokIcon} alt="TikTok" />
                      <img src={SnapchatIcon} alt="Snapchat" />
                      <img src={InstagramIcon} alt="Instagram" />
                      <img src={FaceBookIcon} alt="Facebook" />
                      <img src={TwitterIcon} alt="Twitter" />
                    </div> */}
                    <div className={styles.iconsRow}>
                      <img src={TikTokIcon} alt="TikTok" />
                      <img src={FaceBookIcon} alt="Facebook" />
                      <img src={InstagramIcon} alt="Instagram" />
                      <img src={SnapchatIcon} alt="Snapchat" />
                      <img src={WhatsAppIcon} alt="WhatsApp" />
                      <img src={MessengerIcon} alt="Messenger" />
                      <img src={ShareChatIcon} alt="Sharechat" />
                      <img src={MojIcon} alt="Moj" />
                      <img src={ChingariIcon} alt="Chingari" />
                      <img src={JoshIcon} alt="Josh" />
                      <img src={XIcon} alt="X" />
                    </div>
                  </div>
                  {renderButton(3, SocialShareIcon, 'Pic2Art')}
                </div>
              </div>
              <div className={[styles.option, styles.third].join(' ')}>
                <div>
                  <div>
                    <div className={styles.featureTitle}>
                      QuickCam Crypto Tipping
                    </div>
                    <div className={styles.featureDescription}>
                      Get tipped with community meme coins.
                    </div>
                  </div>
                  {renderButton(10, SocialFiIcon, 'Pic2Art')}
                </div>
              </div>
            </div>
            {width > 1024 && (
              <div className={styles.outerCircle}>
                <div className={styles.middleCircle}>
                  <div className={styles.innerCircle}>
                    {/* <img src={WelcomeVideo} alt="Pic2Art" /> */}
                    <div style={{ position: 'relative' }}>
                      <div
                        style={{
                          position: 'absolute',
                          zIndex: 1,
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <p>Loading...</p>
                      </div>
                      {videoSrc ? (
                        <video
                          autoPlay
                          loop
                          muted={muted}
                          playsInline
                          controls={false}
                          style={{
                            position: 'absolute',
                            zIndex: 10,
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                          }}
                          key={videoSrc}
                          onEnded={() => {
                            handleActions((focusID + 1) % data.length, true);
                          }}
                        >
                          <source src={LandingIntroVideo} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        <img
                          src={ThumbnailSummary}
                          alt="video"
                          style={{
                            height: '95%',
                            width: '100%',
                            zIndex: 1,
                            borderRadius: '30px',
                          }}
                        />
                      )}
                      {/* eslint-disable */}
                      <img
                        src={muted ? IconMute : IconUnmute}
                        className={styles.videoMuteImage}
                        onClick={() => setMuted(!muted)}
                        alt="mute"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className={[styles.options, styles.right].join(' ')}>
              <div className={[styles.option, styles.first].join(' ')}>
                <div>
                  {renderButton(4, GamificationIcon, 'Pic2Art')}
                  <div>
                    <div className={styles.featureTitle}>Gamification</div>
                    <div className={styles.featureDescription}>
                      <p>Challenges, Contest, Prizes and Leaderboards.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={[styles.option, styles.second].join(' ')}>
                <div>
                  {renderButton(5, GameCoinIcon, 'QuickCam Referral Points')}
                  <div>
                    <div className={styles.featureTitle}>
                      QuickCam Referral Points
                    </div>
                    <div className={styles.featureDescription}>
                      Converts into Quickie Community Meme Coins!
                    </div>
                  </div>
                </div>
              </div>
              <div className={[styles.option, styles.second].join(' ')}>
                <div>
                  {renderButton(6, Bonus, 'Make Money Sharing Quickie Videos')}
                  <div>
                    <div className={styles.featureTitle}>
                      Make Money Sharing Quickie Videos
                    </div>
                    <div className={styles.featureDescription}>
                      Earn Crypto Tips from Friends, Fans and Followers
                    </div>
                  </div>
                </div>
              </div>
              <div className={[styles.option, styles.third].join(' ')}>
                <div>
                  {renderButton(7, FreeBetaIcon, 'Free In Beta!')}
                  <div>
                    <div className={styles.featureTitle}>Free In Beta!</div>
                    <div className={styles.featureDescription}>
                      Premium Free Trial In Beta
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.mwebWelcomeContent}>
            <div
              className={[
                styles.verticalButtons,
                styles.verticalLeftButtons,
              ].join(' ')}
            >
              <button
                onClick={() => handleActions(0)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 0
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={FastSlowIcon} alt="Pic2Art" />
              </button>
              <button
                onClick={() => handleActions(1)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 1
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={TrimIcon} alt="Pic2Art" />
              </button>
              <button
                onClick={() => handleActions(2)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 2
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={SocialShareIcon} alt="Pic2Art" />
              </button>
              <button
                onClick={() => handleActions(3)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 3
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={SocialFiIcon} alt="Pic2Art" />
              </button>
            </div>
            <div className={styles.mwebVideoContainerBorder}>
              <div className={styles.featureContainer}>
                <div className={styles.featureTitle}>
                  {data[focusID]?.title}
                </div>
                <div className={styles.featureDescription}>
                  {data[focusID]?.description}
                </div>
              </div>
              {width <= 1024 && (
                <div className={styles.mwebVideoContainer}>
                  {/* <img src={WelcomeVideo} alt="Pic2Art" /> */}
                  <div style={{ position: 'relative' }}>
                    <div
                      style={{
                        position: 'absolute',
                        zIndex: 1,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <p>Loading</p>
                    </div>
                    {videoSrc ? (
                      <video
                        autoPlay
                        loop
                        muted={muted}
                        playsInline
                        controls={false}
                        style={{
                          position: 'absolute',
                          zIndex: 2,
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                        }}
                        key={videoSrc}
                        onEnded={() => {
                          handleActions((focusID + 1) % data.length, true);
                        }}
                      >
                        <source src={LandingIntroVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <img
                        src={ThumbnailSummary}
                        alt="video"
                        style={{
                          height: '95%',
                          width: '100%',
                          zIndex: 1,
                          borderRadius: '30px',
                        }}
                      />
                    )}
                    <img
                      src={muted ? IconMute : IconUnmute}
                      className={styles.videoMuteImage}
                      onClick={() => setMuted(!muted)}
                      alt="mute"
                    />
                  </div>
                </div>
              )}
            </div>
            <div
              className={[
                styles.verticalButtons,
                styles.verticalRightButtons,
              ].join(' ')}
            >
              <button
                onClick={() => handleActions(4)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 4
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={GamificationIcon} alt="Pic2Art" />
              </button>
              <button
                onClick={() => handleActions(5)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 5
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={GameCoinIcon} alt="Pic2Art" />
              </button>
              <button
                onClick={() => handleActions(6)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 6
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={Bonus} alt="Pic2Art" />
              </button>
              <button
                onClick={() => handleActions(7)}
                // onFocus={e => handleShadowOnFocus(e)}
                type="button"
                id="btnIcon"
                className={
                  focusID === 7
                    ? [styles.shadow].join(' ')
                    : [styles.noshadow].join(' ')
                }
              >
                <img src={FreeBetaIcon} alt="Pic2Art" />
              </button>
            </div>
          </div>
          {/* <div style={{ textAlign: 'center', padding: '0 0 1rem 0' }}>
            <div className={styles.featureDescription}>
              QuickCam provides you with unique multi-patented real-time fast &
              slow motion recording feature to make recording, editing & sharing
              videos quick and easy!
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Welcome;
